import { ComponentPropsWithoutRef } from "react";
import * as styles from "./SectionBlockMediaCalloutCard.css";

import { CardCalloutProps } from "~/components/components/cards/CardCallout";
import { BlockMediaCalloutCard } from "~/components/components/blocks/BlockMediaCalloutCard";
import { BlockMediaCalloutCard as IBlockMediaCalloutCard } from "~/sanity/types";

export type SectionBlockMediaCalloutCardProps =
  ComponentPropsWithoutRef<"div"> & {
    data: IBlockMediaCalloutCard;
    theme?: CardCalloutProps["theme"];
    inverted?: boolean;
  };

export const SectionBlockMediaCalloutCard = ({
  data,
  theme = "dark",
  inverted = false,
}: SectionBlockMediaCalloutCardProps) => {
  return (
    data.image &&
    data.cardCallout && (
      <section className={styles.wrapper}>
        <BlockMediaCalloutCard {...data} theme={theme} inverted={inverted} />
      </section>
    )
  );
};
